export const getTranslationsService = async (lang: string) => {
  const response = await fetch(`https://d2cshop.blob.core.windows.net/cdn/phrase/D2CRevamp/master/${lang}.json`);

  if (response.ok) {
    const translations = await response.json();
    return translations;
  } else {
    throw Error('error while fetching translations in phrase');
  }
};
